<template>
  <div class="movieQuiz">
    <!-- 준비 화면 - gamemode : ready -->
    <div v-if="gameMode === 'ready'" class="movie_top"></div>
    <div v-if="gameMode === 'ready'" class="movie_start">
      <a
        v-on:click="() => gamePlay()"
        class="movie_start_btn"
        style="color: chartreuse;"
      />
    </div>
    <!-- 종료 화면 - gamemode : gameover -->
    <div v-show="gameMode === 'gameover'" class="movie_end">
      <div class="movie_gameover">
        GAME OVER
      </div>
      <div ref="gamescore" class="movie_yourscore">
        <p>MOVIE QUIZ</p>
        <p>* YOUR SCORE *</p>
        <p style="font-size: 2rem; color: white;">{{ points }}</p>
        <p v-if="this.points <= 0">POOR</p>
        <p v-else-if="this.points <= 30">FAIR</p>
        <p v-else-if="this.points <= 70">GOOD</p>
        <p v-else-if="this.points <= 120">VERY GOOD</p>
        <p v-else-if="this.points <= 190">EXCELLENT</p>
        <p v-else>UNBELIEVABLE</p>
      </div>
      <p>SHARE IT WITH YOUR FRIENDS</p>
      <share
        url="https://spready.net/movie-quiz"
        title="초성으로 영화제목 맞추기 퀴즈"
        :image="image"
      />
      <div style="margin-top:50px" />
      <a
        v-on:click="() => reset()"
        class="movie_retry_btn"
        style="color: chartreuse;"
      />
    </div>
    <!-- 플레이 화면 - gamemode : playing -->
    <div v-if="gameMode === 'playing'" class="movie_container">
      <!-- 상단 : 시간, 점수, 기회 -->
      <div class="movie_box1">
        <div class="movie_box1_time">
          <p style="user-select: none;">TIME {{ timeLimit }}</p>
        </div>
        <div class="movie_box1_score">
          <p style="user-select: none;">
            SCORE <span id="#movie_quiz_score">{{ points }}</span>
          </p>
        </div>
        <div class="movie_box1_chance">
          <font-awesome-icon
            icon="heart"
            v-for="i in life"
            :key="i"
            style="margin-left: 5px; color: red;"
          />
        </div>
      </div>
      <!-- 중단 : 영화 초성 나오는 부분 -->
      <div class="movie_box2">
        <transition :name="fadeAnimation">
          <div v-if="showOX" class="movie_box_ox">
            {{ oxText }}
          </div>
          <div v-else>
            <div v-if="currentMovie != null" class="movie_box2_title">
              {{ currentMovie.chosung }}
            </div>
            <div
              class="movie_box2_hint"
              v-if="currentMovie != null && isHintVisible"
            >
              {{ currentMovie.hint }}
            </div>
          </div>
        </transition>
      </div>
      <!-- 하단 : 힌트, 정답입력, 패스  -->
      <div class="movie_box3">
        <div class="movie_box2_hint_btn">
          <a v-on:click="() => showHint()" class="movie_btn">
            <font-awesome-icon icon="question" style="color: chartreuse;" />
          </a>
        </div>
        <div class="movie_box2_input">
          <input
            type="text"
            class="movie_input"
            placeholder="정답을 입력해주세요."
            v-model="answer"
            @keypress.prevent.enter="() => checkAnswer()"
          />
        </div>
        <div class="movie_box2_enter_btn">
          <a @click="() => checkAnswer()" class="movie_btn">
            <font-awesome-icon icon="check" style="color: chartreuse;" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import random from "lodash.random";
import { removeWhitespace } from "../utils";
import { CountUp } from "countup.js";
import Share from "./Share";

const GAME_TIME_LIMIT = 180;
const MAX_LIFE = 3;
const POINT_PER_QUESTION = 30;
const COST_HINT = 20;

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export default {
  name: "MovieQuiz",
  components: {
    Share
  },
  data() {
    return {
      timer: null,
      timeLimit: GAME_TIME_LIMIT,
      movies: [],
      isGameOver: false,
      life: MAX_LIFE,
      answer: "",
      points: 0,
      currentMovie: null,
      gameMode: "ready",
      isHintVisible: false,
      haveHint: true,
      showOX: false,
      oxText: "O",
      fadeAnimation: "fade",
      image: null,
      comment: null
    };
  },
  computed: {
    gameTitle() {
      const timeLimitInMinutes = GAME_TIME_LIMIT / 60;
      return `${timeLimitInMinutes}분안에 영화제목 많이 맞추기!!`;
    }
  },
  methods: {
    checkAnswer() {
      // 오답
      if (
        removeWhitespace(this.answer) !==
        removeWhitespace(this.currentMovie.originalName)
      ) {
        this.life--;
        this.oxText = "X";

        if (!this.life) {
          /**
           * css transition이 계속 페이지에 남아있어서 잔상이 보이는 이슈 해결
           * setTimeout으로 비동기적으로 gameMode를 변경
           */
          this.fadeAnimation = "";
          setTimeout(() => {
            this.isGameOver = true;
            this.gameMode = "gameover";
          });
          return;
        }
      } else {
        this.oxText = "O";

        const oldPoints = this.points;
        this.points += this.isHintVisible
          ? POINT_PER_QUESTION - COST_HINT
          : POINT_PER_QUESTION;

        const counter = new CountUp("#movie_quiz_score", this.points);
        counter.startVal = oldPoints;
        counter.start();
      }

      this.showOX = true;
      setTimeout(() => {
        this.showOX = false;
      }, 600);
      this.answer = "";
      this.currentMovie = this.movies[random(0, this.movies.length - 1)];
      this.isHintVisible = false;
      this.haveHint = true;
    },
    reset() {
      this.isGameOver = false;
      this.haveHint = true;
      this.isHintVisible = false;
      this.answer = "";
      this.timeLimit = GAME_TIME_LIMIT;
      this.life = MAX_LIFE;
      this.gameMode = "ready";
      this.points = 0;
      this.comment = null;
      clearTimeout(this.timer);
    },
    showHint() {
      if (!this.haveHint) {
        alert("이미 힌트를 사용하였습니다.");
        return;
      }
      this.haveHint = false;
      this.isHintVisible = true;
    },
    gamePlay() {
      this.gameMode = "playing";
      this.currentMovie = this.movies[random(0, this.movies.length - 1)];
      this.timeLimit = GAME_TIME_LIMIT;
      clearTimeout(this.timer);
      // 게임 시작하면서 countdown 시작
      this.timeLimit--;
    },
    async capture() {
      const gamescoreScreen = this.$refs.gamescore;
      const options = {
        type: "dataURL",
        scale: 2
      };
      const image = await this.$html2canvas(gamescoreScreen, options);
      const file = dataURLtoFile(image, "gamescore.png");
      this.image = file;
    }
  },
  async created() {
    const movies = await fetch(
      "https://s3.ap-northeast-2.amazonaws.com/s.spready.net/movies.json"
    ).then(res => res.json());

    this.movies = movies;
    this.currentMovie = this.movies[random(0, this.movies.length - 1)];
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  watch: {
    timeLimit: {
      handler(value) {
        if (value > 0) {
          this.timer = setTimeout(() => {
            this.timeLimit--;
          }, 1000);
        } else {
          this.gameMode = "gameover";
        }
      }
    },
    gameMode: {
      async handler(value) {
        if (value === "gameover") {
          await this.capture();
        }
      }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap");

.movieQuiz {
  color: chartreuse;
  padding: 0;
  margin: 0;
  height: 100%;
  width: 100%;
  background: black;
  display: flex;
  align-items: center;
  justify-content: top;
  flex-direction: column;
}
.a {
  color: chartreuse;
}
.movie_top {
  display: flex;
  width: 400px;
  height: 450px;
  align-items: center;
  background: url("../assets/moviequiz/moviequiz_main.png") no-repeat center top;
}
.movie_start {
  width: 100%;
  height: 60px;
  margin-top: 30px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: chartreuse;
  flex-direction: column;
}
.movie_end {
  width: 400px;
  padding-bottom: 2rem;
  display: flex;
  text-align: center;
  align-items: center;
  color: chartreuse;
  flex-direction: column;
  font-family: "Press Start 2P", cursive;
  background: url("../assets/moviequiz/moviequiz_end.png") no-repeat center top;
}
.movie_gameover {
  width: 100%;
  height: 180px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  color: chartreuse;
}
.movie_yourscore {
  padding: 50px 40px 30px 40px;
  background: url("../assets/moviequiz/moviequiz_end2.png") no-repeat center top;
}
.movie_start_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  box-shadow: 4px 0 black, -4px 0 black, 0 -4px black, 0 4px black,
    8px 0 chartreuse, -8px 0 chartreuse, 0 -8px chartreuse, 0 8px chartreuse,
    0 0 0 4px chartreuse;
  margin: 8px auto;
  color: chartreuse;
  font-size: 0.7rem;
  font-family: "Press Start 2P", cursive;
}
.movie_start_btn:before {
  content: "START";
  animation: animate infinite 2s;
}
.movie_retry_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 40px;
  box-shadow: 4px 0 black, -4px 0 black, 0 -4px black, 0 4px black,
    8px 0 chartreuse, -8px 0 chartreuse, 0 -8px chartreuse, 0 8px chartreuse,
    0 0 0 4px chartreuse;
  margin: 8px auto;
  color: chartreuse;
  font-size: 0.7rem;
  font-family: "Press Start 2P", cursive;
}
.movie_retry_btn:before {
  content: "RETRY";
  animation: animate infinite 2s;
}
@keyframes animate {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  75% {
    opacity: 1;
  }
}
.movie_container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  width: 400px;
  color: chartreuse;
}
.movie_box1 {
  display: flex;
  height: 30px;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  background: black;
}
.movie_box1 p {
  font-size: 0.7rem;
  font-family: "Press Start 2P", cursive;
}
.movie_box2 {
  height: 150px;
  display: flex;
  text-align: center;
  background: black;
  justify-content: center;
  align-items: center;
}
.movie_box3 {
  display: flex;
  height: 80px;
  flex-direction: row;
  background: black;
}
.movie_box1_time {
  margin-top: 17px;
  width: 33%;
}
.movie_box1_score {
  margin-top: 17px;
  width: 34%;
}
.movie_box1_chance {
  width: 33%;
}
.movie_box2_title {
  display: flex;
  height: 70%;
  font-size: 2.5rem;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}
.movie_box2_hint_text {
  height: 30%;
  font-size: 0.75 rem;
}
.movie_box2_hint_btn {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.movie_box2_input {
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
}
.movie_box2_enter_btn {
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.movie_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  box-shadow: 4px 0 black, -4px 0 black, 0 -4px black, 0 4px black,
    8px 0 chartreuse, -8px 0 chartreuse, 0 -8px chartreuse, 0 8px chartreuse,
    0 0 0 4px chartreuse;
  margin: 8px auto;
  font-size: 0.7rem;
  font-family: "Press Start 2P", cursive;
}
.movie_btn:hover {
  cursor: pointer;
}
.movie_start_btn:hover {
  cursor: pointer;
}
.movie_input {
  width: 180px;
  height: 32px;
  border: 0;
  border-bottom: 2px solid chartreuse;
  outline: 0;
  font-size: 1rem;
  color: chartreuse;
  background: transparent;
  text-align: center;
}
.movie_box_ox {
  font-family: "Press Start 2P", cursive;
  font-size: 3rem;
}
</style>
